import {Component} from '@angular/core';
import {Router} from '@angular/router';
import {ModalToolContainerService} from '@webmate-web-core/shared/tools/modaltoolcontainer/modaltoolcontainer.service';
import {CustomerService} from '@webmate-web-core/shared/services/customer.service';
import {UserNotificationService} from '@webmate-web-core/shared/services/usernotification.service';
import {
    NotificationData,
    NotificationEditorToolComponent,
    NotificationEditorToolConfig
} from '@webmate-web-core/shared/tools/notification-editor/notification-editor-tool.component';
import {WmAdminTopics} from '@webmate-web-core/shared/types/notification';

@Component({
  selector: 'wm-wmadmindropdown',
  styleUrls: ['./wmadmin-dropdown.component.less'],
  template: `
      <div>
          <div class="wm-wmadmindropdown-label" data-testing-id="wmadmindropdown-label" (click)="op.toggle($event)" i18n>
              <ng-content></ng-content>
          </div>
          <p-popover appendTo="body" [styleClass]="'navbar-dropdown'" #op>
              <a class="wm-wmadmindropdown-item" (click)="op.hide()" [routerLink]="['/wmadmin/query-btx']" [ngClass]="{'chosen': router.url === '/wmadmin/query-btx'}">Business Transactions</a>
              <a class="wm-wmadmindropdown-item" (click)="op.hide()" [routerLink]="['/wmadmin/create-customer']" [ngClass]="{'chosen': router.url === '/wmadmin/create-customer'}">Create Customer</a>
              <a class="wm-wmadmindropdown-item" (click)="op.hide()" [routerLink]="['/wmadmin/delete-customer']" [ngClass]="{'chosen': router.url === '/wmadmin/delete-customer'}">Delete Customer</a>
              <a class="wm-wmadmindropdown-item" (click)="op.hide()" [routerLink]="['/wmadmin/impersonate']" [ngClass]="{'chosen': router.url === '/wmadmin/impersonate'}">Impersonate</a>
              <a class="wm-wmadmindropdown-item" (click)="op.hide();openGlobalNotificationModal()">Global Notification</a>
              <a class="wm-wmadmindropdown-item" (click)="op.hide()" [routerLink]="['/wmadmin/slot-administration']" [ngClass]="{'chosen': router.url === '/wmadmin/slot-administration'}">Slot Administration</a>
              <a class="wm-wmadmindropdown-item" (click)="op.hide()" [routerLink]="['/wmadmin/slot-history-viewer']" [ngClass]="{'chosen': router.url === '/wmadmin/slot-history-viewer'}">Slot History</a>
              <a class="wm-wmadmindropdown-item" (click)="op.hide()" [routerLink]="['/wmadmin/redeploy-devices']" [ngClass]="{'chosen': router.url === '/wmadmin/redeploy-devices'}">Redeploy Devices</a>
              <a class="wm-wmadmindropdown-item" (click)="op.hide()" [routerLink]="['/wmadmin/refeed']" [ngClass]="{'chosen': router.url === '/wmadmin/refeed'}">Refeed ...</a>
<!--            <a class="wm-wmadmindropdown-item" (click)="op.hide()"(click)="triggerError()">Throw Error</a>-->
          </p-popover>
      </div>
  `
})
export class WebmateAdminDropdownComponent {

    constructor(public router: Router, private toolService: ModalToolContainerService, private customerService: CustomerService,
                private notificationService: UserNotificationService) {}

    triggerError() {
        throw new Error("Test Error");
    }

    openGlobalNotificationModal() {
        this.toolService.openTool(NotificationEditorToolComponent, new NotificationEditorToolConfig('New Global Admin Notification', this.sendNotification.bind(this), WmAdminTopics, true, ));
    }

    sendNotification(data: NotificationData): void {
        this.notificationService.addNotification$(data.scope, data.topic, data.title, data.text).subscribe(id => {
            this.toolService.closeLastTool();
        });
    }
}
